<template>
  <div class="about">
    <v-container class="constrain">
      <div>
          <v-alert
            border="top"
            colored-border
            type="info"
            elevation="2"
            v-model="success"
            >
            Successfully
            </v-alert>
            <v-alert
            border="top"
            colored-border
            type="info"
            elevation="2"
            v-model="failed"
            dismissible
            >
            Failed To Upload User
            </v-alert>
        <v-row class="pb-5">
          <v-col cols="12">
            <h2 class="white--text">Fighters</h2>
          </v-col>
        </v-row>
        <v-data-table
        dark
            :headers="headers"
            :items="this.fighters"
            sort-by="Name"
            color="none"
            :search="search"
            class="tabless text-center"
          >
            <template v-slot:top>
              <v-toolbar
                class="tabletoolbar"
                flat
              >
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog
                  v-model="dialog"
                  max-width="650px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      New Fighter
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>

                      <v-form 
                        ref="form"
                        v-model="valid"
                      >
                      <v-container>
                        <v-alert
                            border="top"
                            colored-border
                            type="info"
                            elevation="2"
                            v-model="imagedeleted"
                            dismissible
                            >
                                {{ imagedeletedmessage }}
                            </v-alert>
                          <v-alert
                            border="top"
                            colored-border
                            type="info"
                            elevation="2"
                            v-model="urlcreated"
                            dismissible
                            >
                                Image url is ready for upload
                            </v-alert>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            class="text-center"
                          >
                          <!-- <v-badge
                            bordered
                            color="error"
                            icon="mdi-lock"
                            overlap
                            @click="removeImgStorage(editedItem.ImageName)"
                          > -->
                          <img 
                            :src="editedItem.Image" width="200"
                          />
                          <!-- </v-badge> -->
                          
                          <!-- <v-btn @click="removeImgStorage(editedItem.ImageName)"></v-btn> -->
                          </v-col>
                          <v-col class="text-center">
                            <v-progress-circular
                            v-if="loading"
                            indeterminate
                              color="primary"
                            >Loading please wait</v-progress-circular>
                            <v-chip v-else
                              class="ma-2 px-auto"
                              close
                              @click="removeImgStorage(editedItem.ImageName)"
                            >
                              Delete
                            </v-chip>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                          >
                            <v-file-input
                              v-model="files"
                              @change="uploadimagefallback"
                              :rules="[rules.required]"
                              accept="image/*"
                              placeholder="Upload your documents"
                              label="File input"
                              prepend-icon="mdi-paperclip"
                            >
                              <template v-slot:selection="{ text }">
                                <v-chip
                                  small
                                  label
                                  color="primary"
                                >
                                  {{ text }}
                                </v-chip>
                              </template>
                            </v-file-input>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="6"
                          >
                          <v-select
                            v-model="editedItem.weightdivisions"
                            :items="weightdivisions"
                            :rules="[rules.required]"
                            item-text="text"
                            item-value="value"
                            label="Select Weight Division"
                          ></v-select>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="6"
                          >

                          <v-select
                            v-model="editedItem.countries"
                            :items="countries"
                            label="Select"
                            item-text="text"
                            :rules="[rules.required]"
                          >
                            <template v-slot:item="slotProps">
                              <country-flag rounded :country='slotProps.item.value' size='medium' class="mr-2"/>
                              <!-- <i :class="['mr-2', 'em', slotProps.item.]"></i> -->
                              <p class="my-auto">{{slotProps.item.text}}</p>
                            </template>
                          </v-select>
                          
                          <!-- <v-select
                            v-model="editedItem.countries"
                            :items="countries"
                            :rules="[rules.required]"
                            item-text="text"
                            item-value="value"
                            label="Country"
                          ></v-select> -->
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            class="text-center"
                          >
                            <h3>Records</h3>
                          </v-col>

    
                            <v-col
                            cols="12"
                            sm="12"
                            md="2"
                          >
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="editedItem.Wins"
                              label="Wins"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="3"
                          >
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="editedItem.Wins_by_KO"
                              label="Wins by KO"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="2"
                          >
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="editedItem.Losses"
                              label="Losses"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="3"
                          >
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="editedItem.Losses_by_KO"
                              label="Losses by KO"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="2"
                          >
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="editedItem.Draws"
                              label="Draws"
                            ></v-text-field>
                          </v-col>
                          




                          <v-col
                            cols="12"
                            sm="12"
                            md="6"
                          >
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="editedItem.Name"
                              label="Fighter Name"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="6"
                          >
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="editedItem.Surname"
                              label="Fighter Surname"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Prospect"
                              label="Prospect"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Movment"
                              label="Movment"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Accuracy"
                              label="Accuracy"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Durability"
                              label="Durability"
                            ></v-text-field>
                          </v-col>
                           <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Repertoire"
                              label="Repertoire"
                            ></v-text-field>
                          </v-col>
                           <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Ability"
                              label="Ability"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Firepower"
                              label="Firepower"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Determination"
                              label="Determination"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Defense"
                              label="Defense"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Opposition"
                              label="Opposition"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Points"
                              label="Points"
                              :value="getTotalTaxes()"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                            :rules="[rules.required]"
                              v-model="editedItem.Percentage"
                              label="Percentage"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>

                    </v-form>

                    
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-model="newuser"
                        v-if="newuser === false"
                        color="red darken-1"
                        text
                        @click="createDocId()"
                        :disabled="!valid"
                      >
                        Save
                      </v-btn>
                      <v-btn
                        color="red darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn 
                      v-if="newuser === true"
                      color="red darken-1" 
                      text
                      @click="updateuserinfo">
                          Update
                      </v-btn>
                      
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.Image`]="{ item }">
              <v-list-item-avatar>
                    <v-img
                      :src="item.Image"
                    ></v-img>
                  </v-list-item-avatar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <!-- <template v-slot:no-data>
              <v-btn
                color="primary"
              >
                Reset
              </v-btn>
            </template> -->
          </v-data-table>
      </div>
      </v-container>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import db from '../firebaseConfig'
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc, setDoc } from "firebase/firestore";
import { mapGetters } from "vuex";
import countryselector from "../components/countryselector/countryselector.vue";
// import store from "../store";
export default {
  components: {
    countryselector,
    CountryFlag
  },
    data: () => ({
      loading:false,
      imagedeleted:false,
      imagedeletedmessage:'',
      newuser: false,
      name:'',
      id:'',
      urlcreated: false,
      success: false,
      failed: false,
      valid:false,
      search: '',
      dialog: false,
      dialogDelete: false,
      files: [],
      headers: [
        // { text: 'Id', value: 'index' },
        {
          text: 'Image',
          align: 'center',
          sortable: false,
          value: 'Image',
        },
        { text: 'Name', value: 'Name', align: 'center', sortable: false },
        { text: 'Surname', value: 'Surname', align: 'center', sortable: false },
        { text: 'Points', value: 'Points', align: 'center', sortable: false },
        { text: 'Percentage', value: 'Percentage', align: 'center', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      weightdivisions: [
        {text: 'Minimumweight', value:'minimumweight'},
        {text: 'Light Flyweight', value:'light_flyweight'},
        {text: 'Flyweight', value:'flyweight'},
        {text: 'Super Flyweight', value:'super_flyweight'},
        {text: 'Bantamweight', value:'bantamweight'},
        {text: 'Super Bantamweight', value:'super_bantamweight'},
        {text: 'Featherweight', value:'featherweight'},
        {text: 'Super Featherweight', value:'super_featherweight'},
        {text: 'Lightweight', value:'lightweight'},
        {text: 'Super Lightweight', value:'super_lightweight'},
        {text: 'Welterweight', value:'welterweight'},
        {text: 'Super Welterweight', value:'super_welterweight'},
        {text: 'Middleweight', value:'middleweight'},
        {text: 'Super Middleweight', value:'super_middleweight'},
        {text: 'Light Heavyweight', value:'light_heavyweight'},
        {text: 'Cruiserweight', value:'Cruiserweight'},
        {text: 'Heavyweight', value:'heavyweight'},
        {text: 'Multiple', value:'multiple'},
        
      ],
      countries: [
        {text:'Afghanistan',value:'af'},
        {text:'Åland Islands',value:'ax'},
        {text:'Albania',value:'al'},
        {text:'Algeria',value:'dz'},
        {text:'American Samoa',value:'as'},
        {text:'Andorra',value:'ad'},
        {text:'Angola',value:'ao'},
        {text:'Anguilla',value:'ai'},
        {text:'Antarctica',value:'aq'},
        {text:'Antigua and Barbuda',value:'ag'},
        {text:'Argentina',value:'ar'},
        {text:'Armenia',value:'am'},
        {text:'Aruba',value:'aw'},
        {text:'Australia',value:'au'},
        {text:'Austria',value:'at'},
        {text:'Azerbaijan',value:'az'},
        {text:'Bahamas',value:'bs'},
        {text:'Bahrain',value:'bh'},
        {text:'Bangladesh',value:'bd'},
        {text:'Barbados',value:'bb'},
        {text:'Belarus',value:'by'},
        {text:'Belgium',value:'be'},
        {text:'Belize',value:'bz'},
        {text:'Benin',value:'bj'},
        {text:'Bermuda',value:'bm'},
        {text:'Bhutan',value:'bt'},
        {text:'Bolivia (Plurinational State of)',value:'bo'},
        {text:'Bonaire, Sint Eustatius and Saba',value:'bq'},
        {text:'Bosnia and Herzegovina',value:'ba'},
        {text:'Botswana',value:'bw'},
        {text:'Bouvet Island',value:'bv'},
        {text:'Brazil',value:'br'},
        {text:'Virgin Islands (British)',value:'vg'},
        {text:'British Indian Ocean Territory',value:'io'},
        {text:'Brunei Darussalam',value:'bn'},
        {text:'Bulgaria',value:'bg'},
        {text:'Burkina Faso',value:'bf'},
        {text:'Burundi',value:'bi'},
        {text:'Cambodia',value:'kh'},
        {text:'Cameroon',value:'cm'},
        {text:'Canada',value:'ca'},
        {text:'Cabo Verde',value:'cv'},
        {text:'Cayman Islands',value:'ky'},
        {text:'Central African Republic',value:'cf'},
        {text:'Chad',value:'td'},
        {text:'Chile',value:'cl'},
        {text:'China',value:'cn'},
        {text:'Hong Kong',value:'hk'},
        {text:'Macao',value:'mo'},
        {text:'Christmas Island',value:'cx'},
        {text:'Cocos (Keeling) Islands',value:'cc'},
        {text:'Colombia',value:'co'},
        {text:'Comoros',value:'km'},
        {text:'Congo',value:'cg'},
        {text:'Congo, Democratic Republic of the',value:'cd'},
        {text:'Cook Islands',value:'ck'},
        {text:'Costa Rica',value:'cr'},
        {text:'Côte d',value:'ci'},
        {text:'Croatia',value:'hr'},
        {text:'Cuba',value:'cu'},
        {text:'Curaçao',value:'cw'},
        {text:'Cyprus',value:'cy'},
        {text:'Czechia',value:'cz'},
        {text:'Denmark',value:'dk'},
        {text:'Djibouti',value:'dj'},
        {text:'Dominica',value:'dm'},
        {text:'Dominican Republic',value:'do'},
        {text:'Ecuador',value:'ec'},
        {text:'Egypt',value:'eg'},
        {text:'El Salvador',value:'sv'},
        {text:'Equatorial Guinea',value:'gq'},
        {text:'Eritrea',value:'er'},
        {text:'Estonia',value:'ee'},
        {text:'Ethiopia',value:'et'},
        {text:'Falkland Islands (Malvinas)',value:'fk'},
        {text:'Faroe Islands',value:'fo'},
        {text:'Fiji',value:'fj'},
        {text:'Finland',value:'fi'},
        {text:'France',value:'fr'},
        {text:'French Guiana',value:'gf'},
        {text:'French Polynesia',value:'pf'},
        {text:'French Southern Territories',value:'tf'},
        {text:'Gabon',value:'ga'},
        {text:'Gambia',value:'gm'},
        {text:'Georgia',value:'ge'},
        {text:'Germany',value:'de'},
        {text:'Ghana',value:'gh'},
        {text:'Gibraltar',value:'gi'},
        {text:'Greece',value:'gr'},
        {text:'Greenland',value:'gl'},
        {text:'Grenada',value:'gd'},
        {text:'Guadeloupe',value:'gp'},
        {text:'Guam',value:'gu'},
        {text:'Guatemala',value:'gt'},
        {text:'Guernsey',value:'gg'},
        {text:'Guinea',value:'gn'},
        {text:'Guinea-Bissau',value:'gw'},
        {text:'Guyana',value:'gy'},
        {text:'Haiti',value:'ht'},
        {text:'Heard Island and McDonald Islands',value:'hm'},
        {text:'Holy See',value:'va'},
        {text:'Honduras',value:'hn'},
        {text:'Hungary',value:'hu'},
        {text:'Iceland',value:'is'},
        {text:'India',value:'in'},
        {text:'Indonesia',value:'id'},
        {text:'Iran (Islamic Republic of)',value:'ir'},
        {text:'Iraq',value:'iq'},
        {text:'Ireland',value:'ie'},
        {text:'Isle of Man',value:'im'},
        {text:'Israel',value:'il'},
        {text:'Italy',value:'it'},
        {text:'Jamaica',value:'jm'},
        {text:'Japan',value:'jp'},
        {text:'Jersey',value:'je'},
        {text:'Jordan',value:'jo'},
        {text:'Kazakhstan',value:'kz'},
        {text:'Kenya',value:'ke'},
        {text:'Kiribati',value:'ki'},
        {text:'Korea (Democratic Peoples Republic of)',value:'kp'},
        {text:'Korea, Republic of',value:'kr'},
        {text:'Kuwait',value:'kw'},
        {text:'Kyrgyzstan',value:'kg'},
        {text:'Lao Peoples Democratic Republic',value:'la'},
        {text:'Latvia',value:'lv'},
        {text:'Lebanon',value:'lb'},
        {text:'Lesotho',value:'ls'},
        {text:'Liberia',value:'lr'},
        {text:'Libya',value:'ly'},
        {text:'Liechtenstein',value:'li'},
        {text:'Lithuania',value:'lt'},
        {text:'Luxembourg',value:'lu'},
        {text:'North Macedonia',value:'mk'},
        {text:'Madagascar',value:'mg'},
        {text:'Malawi',value:'mw'},
        {text:'Malaysia',value:'my'},
        {text:'Maldives',value:'mv'},
        {text:'Mali',value:'ml'},
        {text:'Malta',value:'mt'},
        {text:'Marshall Islands',value:'mh'},
        {text:'Martinique',value:'mq'},
        {text:'Mauritania',value:'mr'},
        {text:'Mauritius',value:'mu'},
        {text:'Mayotte',value:'yt'},
        {text:'Mexico',value:'mx'},
        {text:'Micronesia (Federated States of)',value:'fm'},
        {text:'Moldova, Republic of',value:'md'},
        {text:'Monaco',value:'mc'},
        {text:'Mongolia',value:'mn'},
        {text:'Montenegro',value:'me'},
        {text:'Montserrat',value:'ms'},
        {text:'Morocco',value:'ma'},
        {text:'Mozambique',value:'mz'},
        {text:'Myanmar',value:'mm'},
        {text:'Namibia',value:'na'},
        {text:'Nauru',value:'nr'},
        {text:'Nepal',value:'np'},
        {text:'Netherlands',value:'nl'},
        {text:'New Caledonia',value:'nc'},
        {text:'New Zealand',value:'nz'},
        {text:'Nicaragua',value:'ni'},
        {text:'Niger',value:'ne'},
        {text:'Nigeria',value:'ng'},
        {text:'Niue',value:'nu'},
        {text:'Norfolk Island',value:'nf'},
        {text:'Northern Mariana Islands',value:'mp'},
        {text:'Norway',value:'no'},
        {text:'Oman',value:'om'},
        {text:'Pakistan',value:'pk'},
        {text:'Palau',value:'pw'},
        {text:'Palestine, State of',value:'ps'},
        {text:'Panama',value:'pa'},
        {text:'Papua New Guinea',value:'pg'},
        {text:'Paraguay',value:'py'},
        {text:'Peru',value:'pe'},
        {text:'Philippines',value:'ph'},
        {text:'Pitcairn',value:'pn'},
        {text:'Poland',value:'pl'},
        {text:'Portugal',value:'pt'},
        {text:'Puerto Rico',value:'pr'},
        {text:'Qatar',value:'qa'},
        {text:'Réunion',value:'re'},
        {text:'Romania',value:'ro'},
        {text:'Russian Federation',value:'ru'},
        {text:'Rwanda',value:'rw'},
        {text:'Saint Barthélemy',value:'bl'},
        {text:'Saint Helena, Ascension and Tristan da Cunha',value:'sh'},
        {text:'Saint Kitts and Nevis',value:'kn'},
        {text:'Saint Lucia',value:'lc'},
        {text:'Saint Martin (French part)',value:'mf'},
        {text:'Saint Pierre and Miquelon',value:'pm'},
        {text:'Saint Vincent and the Grenadines',value:'vc'},
        {text:'Samoa',value:'ws'},
        {text:'San Marino',value:'sm'},
        {text:'Sao Tome and Principe',value:'st'},
        {text:'Saudi Arabia',value:'sa'},
        {text:'Senegal',value:'sn'},
        {text:'Serbia',value:'rs'},
        {text:'Seychelles',value:'sc'},
        {text:'Sierra Leone',value:'sl'},
        {text:'Singapore',value:'sg'},
        {text:'Sint Maarten (Dutch part)',value:'sx'},
        {text:'Slovakia',value:'sk'},
        {text:'Slovenia',value:'si'},
        {text:'Solomon Islands',value:'sb'},
        {text:'Somalia',value:'so'},
        {text:'South Africa',value:'za'},
        {text:'South Georgia and the South Sandwich Islands',value:'gs'},
        {text:'South Sudan',value:'ss'},{text:'Soviet Union',value:'su'},
        {text:'Spain',value:'es'},
        {text:'Sri Lanka',value:'lk'},
        {text:'Sudan',value:'sd'},
        {text:'Suriname',value:'sr'},
        {text:'Svalbard and Jan Mayen',value:'sj'},
        {text:'Eswatini',value:'sz'},
        {text:'Sweden',value:'se'},
        {text:'Switzerland',value:'ch'},
        {text:'Syrian Arab Republic',value:'sy'},
        {text:'Taiwan, Province of China',value:'tw'},
        {text:'Tajikistan',value:'tj'},
        {text:'Tanzania, United Republic of',value:'tz'},
        {text:'Thailand',value:'th'},
        {text:'Timor-Leste',value:'tl'},
        {text:'Togo',value:'tg'},
        {text:'Tokelau',value:'tk'},
        {text:'Tonga',value:'to'},
        {text:'Trinidad and Tobago',value:'tt'},
        {text:'Tunisia',value:'tn'},
        {text:'Turkey',value:'tr'},
        {text:'Turkmenistan',value:'tm'},
        {text:'Turks and Caicos Islands',value:'tc'},
        {text:'Tuvalu',value:'tv'},
        {text:'Uganda',value:'ug'},
        {text:'Ukraine',value:'ua'},
        {text:'United Arab Emirates',value:'ae'},
        {text:'United Kingdom of Great Britain and Northern Ireland',value:'gb'},
        {text:'United States of America',value:'us'},
        {text:'United States Minor Outlying Islands',value:'um'},
        {text:'Uruguay',value:'uy'},
        {text:'Uzbekistan',value:'uz'},
        {text:'Vanuatu',value:'vu'},
        {text:'Venezuela (Bolivarian Republic of)',value:'ve'},
        {text:'Viet Nam',value:'vn'},
        {text:'Virgin Islands (U.S.)',value:'vi'},
        {text:'Wallis and Futuna',value:'wf'},
        {text:'Western Sahara',value:'eh'},
        {text:'Yemen',value:'ye'},
        {text:'Zambia',value:'zm'},
        {text:'Zimbabwe',value:'zw'}
      ],
      // fighters: [],
      editedIndex: -1,
      editedItem: {
        // uid:'',
        ImageName:'',
        Image:'',
        Surname:'',
        Name: '',
        Wins: '',
        Losses:'',
        Draws:'',
        Wins_by_KO : '',
        Losses_by_KO : '',
        weightdivisions:'',
        countries:'',
        Prospect: 0,
        Movment: 0,
        Accuracy: 0,
        Durability: 0,
        Repertoire: 0,
        Ability: 0,
        Firepower: 0,
        Determination: 0,
        Defense: 0,
        Opposition: 0,
        Points: 0,
        Percentage: 0,
      },
      defaultItem: {
        // uid:'',
        ImageName:'',
        Image:'',
        Name: '',
        Wins: '',
        Losses:'',
        Draws:'',
        Wins_by_KO : '',
        Losses_by_KO : '',
        Surname:'',
        weightdivisions:'',
        countries:'',
        Prospect: 0,
        Movment: 0,
        Accuracy: 0,
        Durability: 0,
        Repertoire: 0,
        Ability: 0,
        Firepower: 0,
        Determination: 0,
        Defense: 0,
        Opposition: 0,
        Points: 0,
        Percentage: 0,
        deleteFighter:''
      },
      rules: {
          required: value => !!value || 'Required.',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Fighter' : 'Edit Fighter'
      },
      ...mapGetters([
            'fighters'
      ]),
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    methods: {
    uploadimagefallback(file) {
      this.loading = true
        // console.log('file', file)
        const storage = getStorage();
        this.editedItem.ImageName = file.name
        // console.log('filename', this.editedItem.ImageName)
        const storageRef = ref(storage, 'fighters/' + this.editedItem.ImageName);
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on('state_changed',
            (snapshot) => {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                case 'paused':
                    console.log('Upload is paused');
                    break;
                case 'running':
                    console.log('Upload is running');
                    break;
                }
            }, 
            (error) => {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                case 'storage/unauthorized':
                    // User doesn't have permission to access the object
                    break;
                case 'storage/canceled':
                    // User canceled the upload
                    break;

                // ...

                case 'storage/unknown':
                    // Unknown error occurred, inspect error.serverResponse
                    break;
                }
            }, 
            () => {
                this.loading = false
                this.urlcreated = true
                // Upload completed successfully, now we can get the download URL
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                console.log('File available at', downloadURL);
                this.editedItem.Image = downloadURL
                this.urlcreated = false
                });
            }
            
            );

    },
    async createDocId(){
      try{
        const newFighterRef = doc(collection(db, "fighters"));
        let myid = newFighterRef
        // console.log('newCityRef', newFighterRef)
        let date = new Date();
        const data = {
           uid: myid.id,
           ImageName: this.editedItem.ImageName,
           Image: this.editedItem.Image,
           Name: this.editedItem.Name,
           weightdivisions:this.editedItem.weightdivisions,
           Wins: this.editedItem.Wins,
           Losses:this.editedItem.Losses,
           Draws:this.editedItem.Draws,
           Wins_by_KO : this.editedItem.Wins_by_KO,
           Losses_by_KO : this.editedItem.Losses_by_KO,
           countries:this.editedItem.countries,
           Surname: this.editedItem.Surname,
           Prospect: this.editedItem.Prospect,
           Movment: this.editedItem.Movment,
           Accuracy: this.editedItem.Accuracy,
           Durability: this.editedItem.Durability,
           Repertoire: this.editedItem.Repertoire,
           Ability: this.editedItem.Ability,
           Firepower: this.editedItem.Firepower,
           Determination: this.editedItem.Determination,
           Defense: this.editedItem.Defense,
           Opposition: this.editedItem.Opposition,
           Points: this.editedItem.Points,
           Percentage: this.editedItem.Percentage,
           DateAdded: date.toLocaleString('en-US', {
               weekday: 'short', // long, short, narrow
               day: 'numeric', // numeric, 2-digit
               year: 'numeric', // numeric, 2-digit
               month: 'long', // numeric, 2-digit, long, short, narrow
               hour: 'numeric', // numeric, 2-digit
               minute: 'numeric', // numeric, 2-digit
               second: 'numeric', // numeric, 2-digit
           })
        }

        await setDoc(newFighterRef, data)
        console.log("Document written with ID: ", newFighterRef.id);
        this.success = true
        //his.uploadimagefallback()
        this.save()
        // this.$store.dispatch('setgetallfighters')
        this.success = false
        this.name = ''
      }catch(e){
        this.failed = true
        console.error("Error adding document: ", e);
      }
    },
    validate () {
        this.$refs.form.validate()
    },
    getTotalTaxes() {
            let amount =
                parseInt(this.editedItem.Prospect) +
                parseInt(this.editedItem.Movment) +
                parseInt(this.editedItem.Accuracy) +
                parseInt(this.editedItem.Durability) +
                parseInt(this.editedItem.Repertoire) +
                parseInt(this.editedItem.Ability) +
                parseInt(this.editedItem.Firepower) +
                parseInt(this.editedItem.Determination) +
                parseInt(this.editedItem.Defense) +
                parseInt(this.editedItem.Opposition)

                this.editedItem.Points = amount
                let multiply = (100 * amount)
                // console.log('multiply', multiply)
                let num = (multiply / 30)
                this.editedItem.Percentage = num.toFixed(2)
                return amount

    },
    editItem(item) {
        // this.check_uid()
        this.newuser = true
        this.editedIndex = this.fighters.indexOf(item)
        this.editedItem = Object.assign({}, item)
        // let uid = this.editedItem.id
        // console.log(uid)
        this.dialog = true
    },
    async updateuserinfo() {
    let uid = this.editedItem.uid
    // console.log('update uid', uid.uid)
    let date = new Date()
    const fighterRef = doc(db, "fighters", uid);
        console.log(fighterRef)
        // Set the "capital" field of the city 'DC'
        await setDoc(fighterRef, {
            uid:uid,
            ImageName: this.editedItem.ImageName,
            Image: this.editedItem.Image,
            Name: this.editedItem.Name,
            weightdivisions:this.editedItem.weightdivisions,
            Wins: this.editedItem.Wins,
            Losses:this.editedItem.Losses,
            Draws:this.editedItem.Draws,
            "`Wins by KO`" : this.editedItem.Wins_by_KO,
            "`Losses by KO`" : this.editedItem.Losses_by_KO,
            countries:this.editedItem.countries,
            Surname: this.editedItem.Surname,
            Prospect: this.editedItem.Prospect,
            Movment: this.editedItem.Movment,
            Accuracy: this.editedItem.Accuracy,
            Durability: this.editedItem.Durability,
            Repertoire: this.editedItem.Repertoire,
            Ability: this.editedItem.Ability,
            Firepower: this.editedItem.Firepower,
            Determination: this.editedItem.Determination,
            Defense: this.editedItem.Defense,
            Opposition: this.editedItem.Opposition,
            Points: this.editedItem.Points,
            Percentage: this.editedItem.Percentage,
            DateAdded: date.toLocaleString('en-US', {
                weekday: 'short', // long, short, narrow
                day: 'numeric', // numeric, 2-digit
                year: 'numeric', // numeric, 2-digit
                month: 'long', // numeric, 2-digit, long, short, narrow
                hour: 'numeric', // numeric, 2-digit
                minute: 'numeric', // numeric, 2-digit
                second: 'numeric', // numeric, 2-digit
            })
        });
        // this.$store.dispatch('setgetallfighters')
        this.save()

    },
    removeImgStorage(url) {
      const storage = getStorage();
      // Create a reference to the file to delete
      const imgRef = ref(storage, `fighters/` + url);
      console.log('imgRef', imgRef)
      // Delete the file
      deleteObject(imgRef).then(() => {
        // File deleted successfully
        console.log('deleteObject',imgRef)
        this.imagedeleted = true
        this.imagedeletedmessage = `Image succesfully removed ${imgRef}`

      }).catch((error) => {
        // Uh-oh, an error occurred!
        this.imagedeleted = true
        this.imagedeletedmessage = `Image unsuccesfully removed ${imgRef}`
        console.log('deleteObject',imgRef)
      });
      this.imagedeleted = false
    },
    deleteItem(item) {
        // console.log('delete user', item)
        this.editedIndex = this.fighters.indexOf(item)
        // console.log('delete editedIndex', this.editedIndex)
        this.editedItem = Object.assign({}, item)
        // console.log('delete editedItem', this.editedItem)
        this.deleteFighter(this.editedItem.uid)
        this.dialogDelete = true
    },
    async deleteFighter(item) {
        // console.log('delete user', item)
        await deleteDoc(doc(db, "fighters", item))

    },
    deleteItemConfirm () {
        this.fighters.splice(this.editedIndex, 1)
        //this.deleteFighter()
        this.closeDelete()
    },
    close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
        this.files = []

    },
    closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
    },
    save() {
        if (this.editedIndex > -1) {
          Object.assign(this.fighters[this.editedIndex], this.editedItem)
        } else {
          this.fighters.push(this.editedItem)
        }
        this.$store.dispatch('setgetfights')
        this.validate = true
        this.newuser = false
        // this.files = []
        this.files = []
        this.close()
    },
    },
  }
</script>

<style lang="sass">
.v-toolbar__content
  background: transparent

.normal-flag[data-v-e8c23852] 
    margin: 0px !important
// .tabless tr td
//   text-align: center !important

// .constrain 
//     max-width: 975px
//     margin: 0 auto

</style>
